import React, { useState } from "react";
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { getEntityFullName } from "../components/tools";

export const AddExperienceBlock = ({ dropdownExperiences = [], activeLanguage, lesson, addExperienceToLesson, loading }) => {

    const [dropdownValue, setDropdownValue] = useState()

    const dropdownExperienceHandler = (exerience) => {
        setDropdownValue(exerience);
    }

    const clearDropdownValue = () => {
        setDropdownValue(null);
    }

    return (
        <div className="mt-1 mb-2 ">
            <div className="TabInputBlock ">
                <DropdownButton id="dropdown-basic-button" variant="info" title={dropdownValue ? getEntityFullName(dropdownValue, activeLanguage) : "Select"}
                    className="mr-2 BoxShadowSelect FormText p-2">
                    {dropdownExperiences.map((experience, index) =>
                        <Dropdown.Item key={experience.id} onClick={() => dropdownExperienceHandler(experience)}
                            className="FormTextDark BoxShadow ">
                            {getEntityFullName(experience, activeLanguage)}
                        </Dropdown.Item>
                    )}
                </DropdownButton>
                <button
                    className="ElementButton"
                    type="submit"
                    variant="success"
                    disabled={loading}
                    onClick={(e) => {
                        e.preventDefault();
                        addExperienceToLesson(lesson.id, dropdownValue);
                        clearDropdownValue();
                    }}
                //style={{ fontSize: "1rem", lineHeight: "1rem", padding: "0.2rem 0.5rem" }}
                >
                    Add Experience
                </button>
            </div>
        </div>
    )
};
